import type { Input } from '@builder.io/sdk';

const textSectionField = [
  {
    name: 'content',
    type: 'richText',
  },
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['gray', 'white'],
    defaultValue: 'gray',
  },
] as const satisfies DeepReadonly<Input[]>;

const textSectionConfig = {
  name: 'Text Section',
  inputs: textSectionField,
};

export type TextSectionProps = GenerateBuilder<typeof textSectionField>;

export default textSectionConfig;
